export const CUSTOM_PICKUP_POLICIES = {
  INHERIT: "inherit",
  DISABLED: "disabled",
  FREE: "free",
  PAID: "paid",
};

const toBool = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    return ["1", "true", "yes", "on", "si", "sí"].includes(
      value.trim().toLowerCase()
    );
  }
  return false;
};

const toMoney = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.max(0, Math.round(number * 100) / 100) : 0;
};

const toNullableNumber = (value) => {
  if (value === null || typeof value === "undefined" || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? Math.max(0, Math.round(number * 100) / 100) : null;
};

const normalizePolicy = (value) => {
  const policy = String(value || CUSTOM_PICKUP_POLICIES.INHERIT).toLowerCase();
  return Object.values(CUSTOM_PICKUP_POLICIES).includes(policy)
    ? policy
    : CUSTOM_PICKUP_POLICIES.INHERIT;
};

const normalizeText = (value, maxLength = 160) => {
  const text = String(value ?? "").trim();
  return text.length > 0 ? text.slice(0, maxLength) : "";
};

export function resolveCustomPickupConfig({ optionalFields, formData }) {
  const policy = normalizePolicy(
    formData?.customPickupPolicy ?? formData?.custom_pickup_policy
  );

  const globalEnabled = toBool(optionalFields?.custom_pick_up);
  const globalRequired = globalEnabled && toBool(optionalFields?.custom_pickup_required);
  const globalShowCheckbox =
    typeof optionalFields?.custom_pickup_show_checkbox === "undefined"
      ? true
      : toBool(optionalFields?.custom_pickup_show_checkbox);
  const globalPlaceholder = normalizeText(optionalFields?.custom_pickup_placeholder);
  const globalShowInfoBox =
    typeof optionalFields?.custom_pickup_show_info_box === "undefined"
      ? true
      : toBool(optionalFields?.custom_pickup_show_info_box);
  const globalGpsEnabled = globalEnabled && toBool(optionalFields?.custom_pickup_gps_enabled);
  const globalFeeEnabled = toBool(optionalFields?.custom_pickup_fee_enabled);
  const globalFeeAmount = toMoney(optionalFields?.custom_pickup_fee_amount);
  const globalRadiusKm = toNullableNumber(optionalFields?.custom_pickup_radius_km);

  const tourFeeAmount = toNullableNumber(
    formData?.customPickupFeeAmount ?? formData?.custom_pickup_fee_amount
  );
  const tourRadiusKm = toNullableNumber(
    formData?.customPickupRadiusKm ?? formData?.custom_pickup_radius_km
  );

  let enabled = globalEnabled;
  let feeEnabled = globalFeeEnabled;
  let feeAmount = globalFeeAmount;
  let radiusKm = tourRadiusKm ?? globalRadiusKm;
  let required = globalRequired;

  if (policy === CUSTOM_PICKUP_POLICIES.DISABLED) {
    enabled = false;
    required = false;
    feeEnabled = false;
    feeAmount = 0;
    radiusKm = null;
  }

  if (policy === CUSTOM_PICKUP_POLICIES.FREE) {
    enabled = true;
    feeEnabled = false;
    feeAmount = 0;
  }

  if (policy === CUSTOM_PICKUP_POLICIES.PAID) {
    enabled = true;
    feeEnabled = true;
    feeAmount = toMoney(tourFeeAmount ?? globalFeeAmount);
  }

  required = enabled && required;
  const showCheckbox = enabled && !required && globalShowCheckbox;
  const showInfoBox = enabled && globalShowInfoBox;
  const gpsEnabled = enabled && globalGpsEnabled;
  const address = String(formData?.customPickup ?? formData?.customPickUp ?? "").trim();
  const requested = enabled && (required || toBool(formData?.customPickupRequested) || address.length > 0);
  const chargeAmount = enabled && requested && feeEnabled ? feeAmount : 0;

  return {
    policy,
    enabled,
    required,
    showCheckbox,
    showInfoBox,
    gpsEnabled,
    placeholder: globalPlaceholder,
    requested,
    address,
    feeEnabled,
    feeAmount,
    chargeAmount,
    radiusKm,
  };
}
